import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import { MatDialog, MatPaginator, MatSort, MatTableDataSource, MAT_DIALOG_DATA} from "@angular/material";
import { ToastrService } from "ngx-toastr";
import { first } from "rxjs/operators";
import { EventManagementService } from "src/app/services/event-management.service";
import { UserService } from "src/app/services/user.service";
import { TokenStorage } from "src/app/util/token.storage";
import { WebConstants } from "src/app/util/web.constants";

@Component({
  selector: 'app-event-peo-dialog',
  templateUrl: './event-peo-dialog.component.html',
  styleUrls: ['./event-peo-dialog.component.scss']
})
export class EventPeoDialogComponent implements OnInit {

  public displayedColumns: string[] = [
    "name",
    "emailAddress",
    "phoneNumber",
    "actions",
  ];

  public dataSource = new MatTableDataSource();
  public title: string = WebConstants.MENU_NAMES.EVENT_MANAGEMENT;
  public eventPeoData: any[] = [];
  public selectedPeoId: any;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public eventData: any,
    public eventManagementService: EventManagementService,
    public userService: UserService,
    public tokenStorage: TokenStorage,
    public toastrService: ToastrService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    console.log("Event Management");
    this.getAllEventPeo();
  }

  getAllEventPeo(): void {
    this.eventManagementService.getPeoByEvent(this.eventData.eventId).pipe(first()).subscribe((response) => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.eventPeoData = response.data;
          this.dataSource = new MatTableDataSource(this.eventPeoData);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } 
        else {
          this.toastrService.error(response.value, "Failed To Load Data!");
        }
      });
  }

  removePeoFromEvent(data: any){
    this.selectedPeoId = data.userId;

    let payload = {
      eventId: this.eventData.eventId,
      peoId: this.selectedPeoId
    }

    this.eventManagementService.removePeoFromEvent(payload).pipe(first()).subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.toastrService.success(response.value, "PEO Removed Successfully!");
        this.getAllEventPeo();
      }
      else {
        this.toastrService.error(response.value, "Failed To Remove PEO!");
      }
    });

  }

  closeDialog(): void {
    this.dialog.closeAll();
  }
}
